import { Fragment, ReactElement, ReactNode } from 'react';

import { ddCommon, emphasizeText } from '../fraudSearchResult.style';

interface CommonResultTextProps {
  name: string;
  count: number;
  children: ReactNode;
}

export default function CommonResultText({
  name,
  children,
  count,
}: CommonResultTextProps): ReactElement {
  return (
    <Fragment>
      <dt>{name}</dt>
      <dd css={ddCommon}>
        <p css={emphasizeText(count > 0)} className="result-text">
          신고 건수 {count > 0 ? `있음` : '없음'}
        </p>
        {count > 0 || <p className="no-result-guide">{children}</p>}
      </dd>
    </Fragment>
  );
}
